import { InjectionToken } from '@angular/core';

import { ToastConfig } from './toast.service';

export const TOAST_CONFIG_DATA = new InjectionToken<ToastConfig>('TOAST_CONFIG_DATA');
